import Backbone from 'backbone';
import _ from 'underscore';

const noticeClassMap = {
  1: 'md__notification--normal',
  2: 'md__notification--success',
  3: 'md__notification--warning',
  4: 'md__notification--error',
  5: 'md__notification--info',
};

const iconClassMap = {
  1: 'ri-information-fill',
  2: 'ri-checkbox-circle-fill',
  3: 'ri-information-fill',
  4: 'ri-error-warning-fill',
  5: 'ri-information-fill',
};

const Notice = Backbone.Model.extend({
  getNoticeData(userData) {
    const id = this.get('id');
    const { lang } = userData;
    const type = this.get('type');
    const title = this.get(`title_${lang}`);
    let body = this.get(`body_${lang}`);

    if (title && body) {
      body = body.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
      const titleTemplate = _.template(title);
      const bodyTemplate = _.template(body);

      return {
        id,
        lang,
        title: titleTemplate(userData),
        body: bodyTemplate(userData),
        noticeClass: noticeClassMap[type],
        icon: iconClassMap[type],
      };
    }

    return false;
  },
});

export default Notice;



/** WEBPACK FOOTER **
 ** ./src/models/notice.js
 **/